<template>
  <el-dialog
    title="上传微课"
    :visible.sync="uploadDialogVisible"
    width="864px"
    top="5%"
    @close="flushPage"
  >
    <!-- <el-button
      style="margin-left: -762px"
      size="small"
      type="success"
      @click="submitUploads"
      >上 传</el-button
    > -->
    <el-upload
      multiple
      class="upload-demo"
      ref="upload"
      action="#"
      :limit="1"
      :on-preview="handlePreview"
      :on-remove="handleRemove"
      :on-change="onChange"
      :file-list="fileList"
      :http-request="httpRequest"
      accept=".mp4,.avi,.3gp,.rm,.wmv,.flv"
      :auto-upload="true"
    >
      <div class="shangchuan">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      </div>
    </el-upload>
    <el-progress v-if="jindutiao" :stroke-width="16" :percentage="progressPercent"></el-progress>
  </el-dialog>
</template>

<script>
import { videos } from "../../../components/axios/videos";
export default {
  components: { videos },
  props: ["boardId"],
  data() {
    return {
      jindutiao:false,
      progressPercent:0,
      uploadDialogVisible: false,
      pages: [],
      imgs: "",
      fileList: [],
      fileData: {
        name: "小王",
        age: 18,
      },
      uploadData:{},
    };
  },
  methods: {
    flushPage(){
      this.submitUploads()
      this.$parent.writingData()
      this.$refs.upload.clearFiles();
      this.$refs.upload.abort();
      this.uploadData = []
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    async submitUploads() {
      // this.$refs.upload.submit();
      console.log(this.uploadData)
      // return
       const res = await this.$axios.post("/base/wake/upload",{
          video:this.uploadData.id,
          name:this.uploadData.name,
          size:this.uploadData.size,
          class_id:window.localStorage.getItem("class_id"),
          course_id:window.localStorage.getItem("course_id"),
        });
         if(res.status == 200 && res.data.errCode == 0){
          console.log(res)
          // this.writingData()
          this.$parent.writingData()
          this.uploadDialogVisible = false
          this.$parent.empty = false
          this.$message.success(res.data.message)
        }else{
          // this.$message.error('请上传课件')
        }
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.jindutiao = false
    },
    handlePreview(file) {
      console.log(file);
    },
    // // 上传成功回调
    // onSuccess(val) {
    //   console.log(val);
    //   // this.$refs.upload.clearFiles();
    // },
    // onerror(file) {
    //   console.log(file);
    // },
    // 自定义上传
    async httpRequest(parmas) {
      let formData = new FormData();
      formData.append("file", parmas.file);
      formData.append("path", "socoton");
      const config = {
        onUploadProgress: progressEvent => {
          // progressEvent.loaded:已上传文件大小
          // progressEvent.total:被上传文件的总大小
          this.progressPercent = Number((progressEvent.loaded / progressEvent.total * 100).toFixed(2))
        }
      }
      const res  = await videos.post("/vod/upload", formData,config);
      if (res.data) {
        console.log(res);
        // this.res.data
        this.uploadData = res.data
        this.jindutiao = false
        // this.$message.success("上传成功");
      } else {
        this.jindutiao = false
        // this.$message.error("上传失败");
      }
    },
    onChange(file, fileList) {
      this.jindutiao = true
      // 数据小于0.1M的时候按KB显示
      const size = file.size/1024/1024 > 0.1 ? `(${(file.size/1024/1024).toFixed(1)}M)` : `(${(file.size/1024).toFixed(1)}KB)`
      file.name.indexOf('M')>-1 || file.name.indexOf('KB')>-1 ? file.name : file.name += size
    },
  },
  watch: {
    boardId(newName, oldName) {
      console.log(newName);
      this.boardId = newName;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-progress-bar__outer{
  // top: -40px;
}
/deep/ .el-progress{
  position: relative;
    top: -42px;
    width: 300px;
    left: 450px;
}
.upload-demo {
  padding: 0 23px;
  text-align: left;
  // height: 300px;
  padding-bottom: 20px;
}
.el-upload-list {
  width: 800px;
}
.el-button {
  margin-top: 10px;
  // margin-left: -400px;
  background: #2881cd;
  border: 1px #2881cd;
  z-index: 10000;
}
/deep/ .el-dialog__body {
  margin: auto;
  text-align: center;
  padding: 0;
  height: 480px;
}
.shangchuan {
  margin-top: 20px;
  width: 800px;
  height: 114px;
  border: 1px dashed #92b7d6;
  font-size: 18px;
  background: #f6f8f9;
}
.el-upload__text {
  margin-top: 10px;
}
/deep/ .el-progress__text{
  width: 58px;
  display: inline;
  margin-left: 7px;
  font-size: 14px !important;
}
/deep/ .el-progress{
  display: flex;
}
.el-upload {
  width: 800px;
  height: 700px;
  padding-bottom: 10px !important;
}
.el-icon-upload {
  margin-top: 20px;
  font-size: 30px;
}
.page-img {
  width: 100%;
  // height: 100%;
  height: 400px;
}
/deep/ .el-upload-list__item-name{
  width: 250px !important;
}
</style>


// WEBPACK FOOTER //
// src/view/Panel/weike/upload.vue